<template>
  <div
    class="mb-5 d-flex align-items-center"
    :class="['p-4 wrapper bg-light', { 'rounded-big mx-3': !isTablet }]"
  >
    <div class="p-4 w-100">
      <skeleton-wrapper :is-loading="loading">
        <template v-slot:skeleton>
          <on-boarding-panel-skeleton />
        </template>
        <template v-slot:content>
          <template v-if="isOnboardingInProgress && !isOnboardingCompleted">
            <div class="mb-3">
              <h6 class="mb-0" v-if="streamAleType">{{ trans(streamAleType) }}</h6>
              <h4 class="mb-0">{{ stream.title }}</h4>
            </div>
            <div>
              <div class="row no-gutters align-center justify-center mb-5" v-if="showCarousel">
                <div class="col col-12">
                  <carousel :carousel-settings="carouselSettings">
                    <div v-for="(card, index) in getCards" :key="index">
                      <on-boarding-card :card="card" classesCard="mx-2" @onCta="onCta" />
                    </div>
                  </carousel>
                </div>
              </div>
              <template v-else>
                <div class="row px-2 cards-row pb-4">
                  <div
                    class="card-wrapper col-3 px-2"
                    v-for="(card, index) in getCards"
                    :key="index"
                  >
                    <div class="h-100">
                      <on-boarding-card :card="card" @onCta="onCta" />
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </template>
          <on-boarding-done
            v-else
            imageUrl="/images/home-page/onboarding_done.svg"
            :first-label="trans('onboarding.comming_next')"
            :second-label="trans('onboarding.check_in_completed')"
            :button-label="trans('onboarding.check_in_completed_btn')"
            @hidePanel="onHidePanel"
          />
          <div class="d-flex flex-row align-items-center" v-if="isOnboardingInProgress">
            <radial-progress
              :diameter="55"
              :completed-steps="stream.progress.miu.completed"
              :total-steps="stream.ales[0].groups.length"
              :stroke-width="6"
              :inner-stroke-width="6"
            >
              <small class="text-bold">
                {{ stream.progress.miu.completed }}/{{ stream.progress.miu.count }}
              </small>
            </radial-progress>
          </div>
          <miu-modal
            v-if="miuModalShow"
            :value="miuModalShow"
            :miu-id="miuIdToOpen"
            :stream-id="stream.id"
            :has-redirect="hasRedirect"
            :current-miu-completed="currentMiuCompleted"
            @toggle="toggleModal"
          />
        </template>
      </skeleton-wrapper>
    </div>
  </div>
</template>

<script>
import Carousel from "../../molecules/Carousel";
import OnBoardingCard from "../../molecules/cards/OnBoardingCard";
import MiuModal from "./MiuModal";
import RadialProgress from "../../molecules/RadialProgress";
import OnBoardingDone from "./OnBoardingDone";
import { mapGetters, mapMutations } from "vuex";
import streamMixin from "../../mixins/streamMixin";
import mobileCheckMixin from "../../mixins/mobileCheckMixin";
import SkeletonWrapper from "../SkeletonWrapper";
import OnBoardingPanelSkeleton from "../../molecules/skeletons/OnBoardingPanelSkeleton";

export default {
  name: "OnBoardingPanel",
  components: {
    Carousel,
    RadialProgress,
    MiuModal,
    OnBoardingDone,
    OnBoardingCard,
    SkeletonWrapper,
    OnBoardingPanelSkeleton,
  },
  data() {
    return {
      isOnboardingInProgress: false,
      miuModalShow: false,
      miuIdToOpen: null,
      hasRedirect: "",
      currentMiuCompleted: false,
      loading: true,
      carouselSettings: {
        arrows: false,
        dots: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        initialSlide: 0,
        infinite: false,
        responsive: [
          {
            breakpoint: 769,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 720,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      },
    };
  },
  mounted() {
    this.fetchOnboarding();
  },
  computed: {
    isOnboardingCompleted() {
      return this.stream.progress.miu.completed === this.stream.progress.miu.count;
    },
    streamAleType() {
      if (this.stream.ales.length > 0 && this.stream.ales[0].ale_type) {
        return this.aleTypeTitle(this.stream.ales[0].ale_type.name);
      } else {
        return "";
      }
    },
    ...mapGetters({
      stream: "streams/getCurrentStreamData",
    }),
    showCarousel() {
      if (this.isTablet) return true;

      return false;
    },
    getCards() {
      let cards = [];

      for (let ale of this.stream.ales) {
        for (let group of ale.groups) {
          for (let card of group.elements) {
            cards.push(card);
          }
        }
      }

      return cards;
    },
  },
  methods: {
    ...mapMutations({
      currentAle: "streams/setCurrentAleId",
      setOnboardingStream: "streams/setStream",
      resetStream: "streams/resetStream",
    }),
    async fetchOnboarding() {
      try {
        const res = await this.$axios.get("/api/rest/onboarding/cards");
        if (res.data.onboarding[0]) {
          this.setOnboardingStream(res.data.onboarding[0]);
          this.isOnboardingInProgress = true;
        }
        this.loading = false;
      } catch (err) {
        console.log(err);
        this.loading = false;
        this.onHidePanel();
      }
    },
    onCta(card) {
      this.toggleModal();
      this.miuIdToOpen = card.id;
      this.currentAle(card.aleId);
      this.currentMiuCompleted = card.completed;
      if (card.hasOwnProperty("redirect_to") && card.redirect_to) {
        this.hasRedirect = card.redirect_to;
      }
    },
    toggleModal() {
      this.miuModalShow = !this.miuModalShow;
    },
    onProgramCardClick() {
      if (this.$route.hash) {
        this.$router.push({ name: "servicedashboard", hash: "" });
      }
      setTimeout(() => this.$router.push({ name: "servicedashboard", hash: "#path" }), 100);
    },
    onHidePanel() {
      this.$emit("onHide");
    },
  },
  mixins: [streamMixin, mobileCheckMixin],
};
</script>

<style scoped>
.wrapper {
  min-height: 460px;
}
</style>
